import React from 'react';
import BobineVideoPlayer from '../BobineVideoPlayer';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;

const VideoSection = ({ videos, setVideos, playingVideo, setPlayingVideo, token, t }) => {
  if (videos.length === 0) return null;

  return (
    <>
      <div style={{ marginTop: 40 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
          </svg>
          <h3 style={{ fontFamily: "'Georgia', serif", fontSize: 16, color: '#D4AF37', margin: 0, fontWeight: 400 }}>
            {t('dash_videos_title') || 'Souvenirs en mouvement'} ({videos.length})
          </h3>
          <span style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#FAF3E0', fontStyle: 'italic' }}>
            1 video = 50 photos
          </span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
          {videos.map(v => (
            <div key={v.id} data-testid={`video-card-${v.id}`} style={{
              position: 'relative', borderRadius: 10, overflow: 'hidden',
              border: '1px solid rgba(212,175,55,0.12)', backgroundColor: 'rgba(0,0,0,0.3)',
              cursor: 'pointer', transition: 'all 0.3s',
            }}
              onClick={() => setPlayingVideo(v)}
              onMouseEnter={e => { e.currentTarget.style.borderColor = '#D4AF37'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = '#D4AF37'; }}
            >
              <div style={{ aspectRatio: '16/9', backgroundColor: 'rgba(212,175,55,0.03)', position: 'relative' }}>
                {v.has_thumbnail ? (
                  <img src={`${API}/videos/${v.id}/thumbnail`} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                  <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgba(212,175,55,0.3)" strokeWidth="1.5">
                      <polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
                    </svg>
                  </div>
                )}
                <div style={{
                  position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  backgroundColor: 'rgba(0,0,0,0.3)', transition: 'background-color 0.3s',
                }}>
                  <div style={{
                    width: 42, height: 42, borderRadius: '50%', backgroundColor: 'rgba(212,175,55,0.85)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 2px 12px rgba(212,175,55,0.3)',
                  }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="#000" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                  </div>
                </div>
              </div>
              <div style={{ padding: '10px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                  {(() => {
                    const cap = v.caption && !/^\d+$/.test(v.caption.replace(/\.\w+$/, '')) ? v.caption : null;
                    return cap || `Bobine Vive ${new Date(v.created_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}`;
                  })()}
                </span>
                <button
                  data-testid={`delete-video-${v.id}`}
                  onClick={async (e) => {
                    e.stopPropagation();
                    if (!window.confirm('Supprimer cette video ?')) return;
                    try {
                      await fetch(`${API}/videos/${v.id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
                      setVideos(prev => prev.filter(x => x.id !== v.id));
                    } catch { /* silent */ }
                  }}
                  style={{ background: 'none', border: 'none', color: '#FAF3E0', cursor: 'pointer', padding: 4 }}
                >
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/></svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Video Player Modal */}
      {playingVideo && (
        <div
          data-testid="video-player-modal"
          onClick={async () => {
            const inp = document.querySelector('[data-testid="video-caption-input"]');
            if (inp) {
              const val = inp.value.trim();
              if (val && val !== (playingVideo.caption || '')) {
                try {
                  await fetch(`${API}/videos/${playingVideo.id}/caption`, {
                    method: 'PUT', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({ caption: val }),
                  });
                  setVideos(prev => prev.map(v => v.id === playingVideo.id ? { ...v, caption: val } : v));
                } catch {}
              }
            }
            setPlayingVideo(null);
          }}
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            backgroundColor: 'rgba(0,0,0,0.95)', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            flexDirection: 'column', gap: 16,
          }}
        >
          <div onClick={e => e.stopPropagation()} style={{ maxWidth: '90vw', maxHeight: '70vh', width: '100%', maxWidth: 800 }}>
            <BobineVideoPlayer
              testId="modal-video-player"
              src={`${API}/videos/${playingVideo.id}/stream`}
              autoPlay
              style={{ maxHeight: '70vh', border: '1px solid rgba(212,175,55,0.2)' }}
            />
          </div>
          <div onClick={e => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, maxWidth: '80vw' }}>
            <input
              data-testid="video-caption-input"
              type="text"
              placeholder="Nommez ce souvenir (ex: Mariage de Manon...)"
              defaultValue={(() => {
                const cap = playingVideo.caption || '';
                return /^\d+$/.test(cap.replace(/\.\w+$/, '')) ? '' : cap;
              })()}
              onKeyDown={async (e) => {
                if (e.key === 'Enter') {
                  const val = e.target.value.trim();
                  if (val) {
                    try {
                      await fetch(`${API}/videos/${playingVideo.id}/caption`, {
                        method: 'PUT', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                        body: JSON.stringify({ caption: val }),
                      });
                      setVideos(prev => prev.map(v => v.id === playingVideo.id ? { ...v, caption: val } : v));
                      setPlayingVideo(prev => ({ ...prev, caption: val }));
                      e.target.style.borderBottomColor = '#27ae60';
                      setTimeout(() => { if(e.target) e.target.style.borderBottomColor = '#D4AF37'; }, 1500);
                    } catch {}
                  }
                }
              }}
              style={{
                fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37',
                backgroundColor: 'transparent', border: 'none',
                borderBottom: '1px solid rgba(212,175,55,0.3)',
                padding: '6px 12px', textAlign: 'center', width: '100%', maxWidth: 400,
                outline: 'none', caretColor: '#D4AF37',
              }}
            />
            <span style={{ fontFamily: "'Georgia', serif", fontSize: 10, color: '#D4AF37' }}>
              Tapez Entree pour sauvegarder
            </span>
          </div>
          <button
            onClick={() => setPlayingVideo(null)}
            data-testid="close-video-player"
            style={{
              fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0',
              background: 'none', border: '1px solid rgba(212,175,55,0.2)',
              padding: '8px 20px', borderRadius: 6, cursor: 'pointer',
            }}
          >
            Fermer
          </button>
        </div>
      )}
    </>
  );
};

export default VideoSection;
